module.exports = __webpack_public_path__ + "static/media/icon_106.5d28e376.svg";